/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Partially_PaidInputs */

const cs_enum_partially_paid = /** @type {(inputs: Enum_Partially_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Částečně zaplaceno`)
};

const en_enum_partially_paid = /** @type {(inputs: Enum_Partially_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partially paid`)
};

/**
* | output |
* | --- |
* | "Partially paid" |
*
* @param {Enum_Partially_PaidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_partially_paid = /** @type {((inputs?: Enum_Partially_PaidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Partially_PaidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_partially_paid(inputs)
	return cs_enum_partially_paid(inputs)
});